import { render, staticRenderFns } from "./SocialSharingLink.vue?vue&type=template&id=2fac0b1b&scoped=true"
import script from "./SocialSharingLink.vue?vue&type=script&lang=js"
export * from "./SocialSharingLink.vue?vue&type=script&lang=js"
import style0 from "./SocialSharingLink.vue?vue&type=style&index=0&id=2fac0b1b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac0b1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/giuseppe/Sites/mondopavimenti/web/app/themes/mondopavimenti-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fac0b1b')) {
      api.createRecord('2fac0b1b', component.options)
    } else {
      api.reload('2fac0b1b', component.options)
    }
    module.hot.accept("./SocialSharingLink.vue?vue&type=template&id=2fac0b1b&scoped=true", function () {
      api.rerender('2fac0b1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/components/SocialSharingLink.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/components/SocialSharingLink.vue
// module id = 154
// module chunks = 0